import { Dispatch } from 'react';
import * as ActionTypes from 'src/constants/ActionTypes';
import { IStateMallCategory, IStoreState } from 'src/entity/StateEntity';
import { IMallCategory } from '../../entity/MallEntity';
import { MallService } from '../../services/MallService';

export function reloadMallCategory(): IStateMallCategory {
  return {
    reload: true,
    isFetching: false,
    type: ActionTypes.MALL_CATEGORY_STATUS_RELOAD,
    categoryList: [],
  };
}

export function requestMallCategory(): IStateMallCategory {
  return {
    reload: false,
    isFetching: true,
    type: ActionTypes.MALL_CATEGORY_STATUS_REQUEST,
    categoryList: [],
  };
}

function receiveMallCategory(categoryList: IMallCategory[], isSuccess: boolean): IStateMallCategory {
  return {
    reload: !isSuccess,
    isFetching: false,
    type: isSuccess ? ActionTypes.MALL_CATEGORY_STATUS_SUCCESS : ActionTypes.MALL_CATEGORY_STATUS_FAILURE,
    categoryList,
  };
}

export function fetchMallCategory(): any {
  return async (dispatch: Dispatch<IStateMallCategory>) => {
    dispatch(requestMallCategory());
    return MallService.getAllMallCategory()
      .then(res => dispatch(receiveMallCategory(res.results, true)))
      .catch(error => dispatch(receiveMallCategory([], false)));
  };
}

export function shouldFetchMallCategory(mallCategoryState: IStateMallCategory): boolean {
  return (mallCategoryState.reload || mallCategoryState.categoryList.length === 0) && !mallCategoryState.isFetching;
}

export function fetchMallCategoryIfNeeded(): any {
  return (dispatch: Dispatch<IStateMallCategory>, getState: any) => {
    const { mallCategoryState } = getState() as IStoreState;
    if (shouldFetchMallCategory(mallCategoryState)) {
      return dispatch(fetchMallCategory());
    }
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/mallCategoryCreator.ts